module.exports = __webpack_public_path__ + "static/hart-2bd5bc77fbb1228cdd1359ed7de4ef2e.png";